import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=1cc61b9f&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "./Letter.vue?vue&type=style&index=0&id=1cc61b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc61b9f",
  null
  
)

export default component.exports